import { hostData } from '../utils/urlHelpers';
import { useGlobalStore } from '~/stores/global';
import { tokens } from '~/common/const';

export default defineNuxtRouteMiddleware((to, from) => {
  // auth.global
  const app = useNuxtApp();
  if (app?.$cookies?.get(tokens.refresh_token)) {
    navigateTo('/', { replace: true, redirectCode: 307 });
  }
  const globalStore = useGlobalStore();
  // saveBackUrl.global
  if (from?.path) {
    globalStore.setBackUrl(from?.fullPath);
  }

  // routerCityChange.global
  const region = globalStore?.region;
  const needRedirect = region?.needRedirect;
  if (!import.meta.env.SSR && needRedirect) {
    // Если пользователь на корневом домене и доммен != (кука||ip) и пользователь подтвердил что кука или ip правильны
    const { domainWithPort } = hostData(
      window.location.hostname,
      window.location.port
    );

    window.location.href =
      window.location.protocol +
      '//' +
      (region.subdomain ? region.subdomain + '.' : '') +
      domainWithPort +
      to.fullPath;
  }
  // redirect.global
  const url = to.fullPath;
  if (url.includes('lekarstvennye-preparaty')) {
    return navigateTo('/', { replace: true, redirectCode: 301 });
  }
});
